import { all, AllEffect } from 'redux-saga/effects';
import UsersReducer from './duck/reducer';
import { watchGetSearchUsers, watchGetUsers } from './duck/saga';

function* UsersSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetUsers(), watchGetSearchUsers()]);
}

export { UsersReducer, UsersSaga };
